import { Environment } from "./environment.interface";

export const environment: Environment = {
    name: "Dev",
    isProduction: false,
    api: {
        host: "https://qa.weighttracker.nuyken.dev"
    },
    keycloak: {
        host: "https://login.nuyken.dev",
        realm: "development",
        clientId: "WeightTracker"
    }
};
